"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const SearchPage_1 = __importDefault(require("../states/SearchPage"));
const StatisticTable = ({ tableRef, column, level1, level2, level3, topBottom, count = 10, getResult, selectedBenchmark, hideEmptyValues, setProgress }) => {
    const [displayData, setDisplayData] = (0, react_1.useState)([]);
    const [currentChunk, setCurrentChunk] = (0, react_1.useState)(0);
    const chunkSize = 500; // Adjust the chunk size as needed
    const prepareData = (0, react_1.useCallback)(() => {
        var _a, _b, _c, _d;
        if (!!column.key && !!level1.key) {
            return (_b = (_a = SearchPage_1.default.displayedResult) === null || _a === void 0 ? void 0 : _a.flatMap((option1) => {
                var _a;
                const level2Data = (_a = level2 === null || level2 === void 0 ? void 0 : level2.options) !== null && _a !== void 0 ? _a : [null];
                return level2Data.flatMap((option2) => {
                    var _a;
                    const level3Data = (_a = level3 === null || level3 === void 0 ? void 0 : level3.options) !== null && _a !== void 0 ? _a : [null];
                    return level3Data.map((option3) => ({
                        key: `${option1.value}-${option2 === null || option2 === void 0 ? void 0 : option2.value}-${option3 === null || option3 === void 0 ? void 0 : option3.value}`,
                        option1,
                        option2,
                        option3,
                    }));
                });
            })) !== null && _b !== void 0 ? _b : [];
        }
        else if (!column.key && !!level1.key) {
            let list = (_d = (_c = SearchPage_1.default.displayedResult) === null || _c === void 0 ? void 0 : _c.map((item) => (Object.assign(Object.assign({}, item), { result: getResult(null, item.value, null, null, selectedBenchmark) })))) !== null && _d !== void 0 ? _d : [];
            if (topBottom) {
                list = list.map((item) => {
                    const result = item.result;
                    let parsedResult = null;
                    if (typeof result === 'string' && result !== '-') {
                        if (result.includes('/')) {
                            const [numerator, denominator] = result.split('/').map(Number);
                            parsedResult = denominator ? numerator / denominator : null;
                        }
                        else if (result.includes('%')) {
                            parsedResult = parseFloat(result.replace('%', '').replace('+', '')) / 100;
                        }
                        else {
                            parsedResult = parseFloat(result);
                        }
                    }
                    else if (typeof result === 'number') {
                        parsedResult = result;
                    }
                    return Object.assign(Object.assign({}, item), { parsedResult: parsedResult });
                }).filter((item) => item.parsedResult !== null)
                    .sort((a, b) => {
                    return topBottom === 'top'
                        ? b.parsedResult - a.parsedResult
                        : a.parsedResult - b.parsedResult;
                }).slice(0, count);
            }
            return list.map((option1) => ({
                key: option1.value,
                option1,
                result: option1.result,
            }));
        }
        return [];
    }, [column, level1, level2, level3, topBottom, count, getResult, selectedBenchmark]);
    const data = (0, react_1.useMemo)(prepareData, [prepareData, SearchPage_1.default.showStatistics, SearchPage_1.default.displayedResult]);
    const filterEmptyValues = (0, react_1.useCallback)((data) => {
        var _a, _b, _c;
        if (level1.key === "regions" && level2.key === "countries") {
            data = data.filter(({ option1, option2 }) => option1.value === option2.region);
        }
        else if (level1.key === "countries" && level2.key === "regions") {
            data = data.filter(({ option1, option2 }) => option1.region === option2.value);
        }
        if (!hideEmptyValues) {
            return {
                filteredData: data,
                filteredColumns: (_a = column.options) !== null && _a !== void 0 ? _a : [],
            };
        }
        const isEmpty = (value) => value === null || value === undefined || value === '-' || value === '';
        const filteredColumns = (_c = (_b = column.options) === null || _b === void 0 ? void 0 : _b.filter((col) => {
            return data.some(({ option1, option2, option3 }) => {
                return !isEmpty(getResult(col.value, option1.value, (option2 === null || option2 === void 0 ? void 0 : option2.value) || null, (option3 === null || option3 === void 0 ? void 0 : option3.value) || null));
            });
        })) !== null && _c !== void 0 ? _c : [];
        const filteredData = data.filter(({ option1, option2, option3, result }) => {
            if (!column.key && !!level1.key) {
                return !isEmpty(result);
            }
            return filteredColumns.some((col) => {
                return !isEmpty(getResult(col.value, option1.value, (option2 === null || option2 === void 0 ? void 0 : option2.value) || null, (option3 === null || option3 === void 0 ? void 0 : option3.value) || null));
            });
        });
        return { filteredData, filteredColumns };
    }, [hideEmptyValues, column, getResult]);
    const { filteredData, filteredColumns } = (0, react_1.useMemo)(() => filterEmptyValues(data), [data, hideEmptyValues, filterEmptyValues]);
    const calculateRowSpan = (0, react_1.useCallback)((option, levelOptions) => {
        var _a, _b;
        if (!levelOptions)
            return 1;
        return levelOptions.length * ((_b = (_a = level3 === null || level3 === void 0 ? void 0 : level3.options) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 1);
    }, [level3]);
    (0, react_1.useEffect)(() => {
        setDisplayData(filteredData.slice(0, chunkSize));
        setCurrentChunk(1);
    }, [filteredData, chunkSize]);
    (0, react_1.useEffect)(() => {
        if (currentChunk * chunkSize >= filteredData.length)
            return; // Stop if all data is loaded
        const intervalId = setInterval(() => {
            setCurrentChunk((prevChunk) => {
                const newChunk = prevChunk + 1;
                const newData = filteredData.slice(0, newChunk * chunkSize);
                setDisplayData(newData);
                if (newData.length === filteredData.length) {
                    clearInterval(intervalId);
                }
                return newChunk;
            });
        }, 1000); // Adjust the interval time as needed
        return () => clearInterval(intervalId);
    }, [currentChunk, filteredData, chunkSize]);
    const renderedList = (0, react_1.useMemo)(() => {
        if (!!column.key && !!level1.key) {
            let level1Rendered = {};
            let level2Rendered = {};
            return displayData.flatMap(({ key, option1, option2, option3 }) => {
                var _a, _b;
                const rowSpan1 = option1 ? filteredData.filter((val) => val.option1.label === option1.label).length : calculateRowSpan(option1, level2 === null || level2 === void 0 ? void 0 : level2.options);
                const rowSpan2 = option2 ? filteredData.filter((val) => { var _a; return val.option1.label === option1.label && ((_a = val.option2) === null || _a === void 0 ? void 0 : _a.label) === option2.label; }).length : calculateRowSpan(option2, level3 === null || level3 === void 0 ? void 0 : level3.options);
                const shouldRenderLevel1 = !level1Rendered[option1.value];
                const shouldRenderLevel2 = !level2Rendered[`${option1.value}-${option2 === null || option2 === void 0 ? void 0 : option2.value}`];
                level1Rendered[option1.value] = true;
                level2Rendered[`${option1.value}-${option2 === null || option2 === void 0 ? void 0 : option2.value}`] = true;
                return ((0, jsx_runtime_1.jsx)(react_1.default.Fragment, { children: (0, jsx_runtime_1.jsxs)("tr", { children: [shouldRenderLevel1 && ((0, jsx_runtime_1.jsx)("td", { className: 'text-gray-500 text-sm text-nowrap text-center border p-[0.5rem]', rowSpan: rowSpan1, children: option1.label })), shouldRenderLevel2 && option2 && ((0, jsx_runtime_1.jsx)("td", { className: 'text-gray-500 text-sm text-nowrap text-center border p-[0.5rem]', rowSpan: rowSpan2, children: (_a = option2.label) !== null && _a !== void 0 ? _a : '-' })), !!level3.key && option3 && ((0, jsx_runtime_1.jsx)("td", { className: 'text-gray-500 text-sm text-nowrap text-center border p-[0.5rem]', children: (_b = option3.label) !== null && _b !== void 0 ? _b : '-' })), filteredColumns.map((columnOption) => ((0, jsx_runtime_1.jsx)("td", { className: 'text-gray-500 text-sm text-nowrap text-center border p-[0.5rem]', children: getResult(columnOption.value, option1.value, option2 === null || option2 === void 0 ? void 0 : option2.value, option3 === null || option3 === void 0 ? void 0 : option3.value) }, columnOption.value)))] }) }, key));
            });
        }
        else if (!column.key && !!level1.key) {
            return displayData.map(({ key, option1, result }) => ((0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("td", { className: 'text-gray-500 text-sm text-nowrap text-center border p-[0.5rem]', children: option1.label }), (0, jsx_runtime_1.jsx)("td", { className: 'text-gray-500 text-sm text-nowrap text-center border p-[0.5rem]', children: result })] }, key)));
        }
        return [];
    }, [displayData, filteredData, filteredColumns, column.key, level1.key, calculateRowSpan, getResult]);
    const thead = (0, react_1.useMemo)(() => {
        var _a;
        return ((0, jsx_runtime_1.jsxs)("thead", { className: 'text-xs text-gray-700 uppercase bg-gray-50 sticky top-0', children: [!!column.key && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("tr", { children: [[level1, level2, level3].filter((child) => !!child.key)
                                    .map((child, index) => ((0, jsx_runtime_1.jsx)("th", { className: 'text-sm text-nowrap p-[0.5rem] border', children: child.title }, index))), (0, jsx_runtime_1.jsx)("th", { colSpan: (_a = filteredColumns.length) !== null && _a !== void 0 ? _a : 1, className: 'text-sm text-nowrap p-[0.5rem] border', children: column.title })] }), (0, jsx_runtime_1.jsxs)("tr", { children: [[level1, level2, level3].filter((child) => !!child.key)
                                    .map((child, index) => ((0, jsx_runtime_1.jsx)("th", { className: 'text-sm text-nowrap p-[0.5rem] border' }, index))), filteredColumns.map((option, index) => ((0, jsx_runtime_1.jsx)("th", { className: 'text-sm text-nowrap p-[0.5rem] border', children: option.label }, index)))] })] })), !column.key && !!level1.key && ((0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("th", { className: 'text-sm text-nowrap p-[0.5rem] border', children: level1.title }), (0, jsx_runtime_1.jsx)("th", { className: 'text-sm text-nowrap p-[0.5rem] border', children: "Result" })] }))] }));
    }, [filteredData, filteredColumns, column.key, level1.key, getResult]);
    (0, react_1.useEffect)(() => {
        setProgress(Math.floor(Math.min((currentChunk * chunkSize / filteredData.length) * 100, 100)));
    }, [currentChunk, chunkSize, filteredData.length]);
    return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)("table", { ref: tableRef, className: 'w-full text-sm text-left rtl:text-right text-gray-500 border table-report', children: [thead, (0, jsx_runtime_1.jsx)("tbody", { children: renderedList })] }) }));
};
exports.default = StatisticTable;
